import { formatDistanceToNow, format } from 'date-fns'

import { useStyles, PlaceholderTile, Title4 } from '@signavio/ui'
import i18n from '@signavio/i18n'
import { useApi, types, useUser } from '@signavio/effektif-api'
import { Markdown, getDateFnsLocale, ThemeT } from '@signavio/effektif-commons'

import about from '../../about'

export function SWADetails() {
  const user = useUser()

  const style = useStyles(defaultStyles, {})

  const [fetchAboutRequest] = useApi(types.ABOUT)
  return (
    <div>
      <div {...style('section')}>
        <Title4>{i18n('Version')}</Title4>

        {about.version}
      </div>

      {user.systemAdmin && (
        <div {...style('section')}>
          <Title4>{i18n('Last updated')}</Title4>

          {i18n('__relative__ ago on __absolute__', {
            relative: formatDistanceToNow(new Date(about.buildDate), {
              locale: getDateFnsLocale(),
            }),
            absolute: format(new Date(about.buildDate), 'PPpp', {
              locale: getDateFnsLocale(),
            }),
          })}
        </div>
      )}

      <div {...style('section')}>
        <Title4>{i18n('Release Notes')}</Title4>

        {fetchAboutRequest.pending ? (
          Array(5)
            .fill(null)
            /* index is the only option available */
            /* eslint-disable react/no-array-index-key*/
            .map((_, index) => <PlaceholderTile key={index} transparent />)
        ) : (
          <Markdown>{fetchAboutRequest.value.releaseNote?.notes}</Markdown>
        )}
      </div>

      {user.systemAdmin && (
        <div {...style('section')}>
          <Title4>{i18n('Latest changes')}</Title4>

          <table className="table">
            <thead>
              <tr>
                <th>{i18n('Reference')}</th>
                <th>{i18n('Date')}</th>
                <th>{i18n('Author')}</th>
              </tr>
            </thead>
            <tbody>
              {about.changelog.map(({ sha, date, author }) => (
                <tr key={sha}>
                  <td>{sha}</td>
                  <td>
                    {date &&
                      format(new Date(date), 'PPPpp', {
                        locale: getDateFnsLocale(),
                      })}
                  </td>
                  <td>{author}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

const defaultStyles = ({ padding }: ThemeT) => ({
  section: {
    marginBottom: padding.normal,
  },
})
